import { Injectable } from '@angular/core';

/**
 * Service that contains method for dom manipulation.
 * */
@Injectable()
export class DomHandler {

  /**
   * Move the containers scroll to the top/bottom edge of the element if the element is out of the container.
   *
   * @param {any} container - Scrollable DOM container reference
   * @param {any} element - DOM element that is placed inside the container
   * */
  public scrollToElement(container, element) {
    const elementRect: ClientRect = element.getBoundingClientRect();
    const containerRect: ClientRect = container.getBoundingClientRect();

    let scrollAmount = 0;

    if (elementRect.bottom > containerRect.bottom) {
      scrollAmount = elementRect.bottom - containerRect.bottom;
    }

    if (elementRect.top < containerRect.top) {
      scrollAmount = elementRect.top - containerRect.top;
    }

    container.scrollTop += Math.round(scrollAmount);
  }

}
